import { render, staticRenderFns } from "./dyTaxationFormList.vue?vue&type=template&id=19ae9aa6&scoped=true&"
import script from "./dyTaxationFormList.vue?vue&type=script&lang=js&"
export * from "./dyTaxationFormList.vue?vue&type=script&lang=js&"
import style0 from "./dyTaxationFormList.vue?vue&type=style&index=0&id=19ae9aa6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ae9aa6",
  null
  
)

export default component.exports